// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentHeaderTabs_wrapper__vLr8w"};